import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_FlipImage = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/flip-image',
			name: 'Flip Image Online — Mirror & Flip Picture | Lift',
			description:
				"Flip image online instantly with Lift's easy photo flipper. No watermark. Upload photo, flip picture horizontally or vertically, create a perfect mirror image, and download in seconds. Try now!",
			url: 'https://liftapp.ai/flip-image',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/flip-image#product' },
				{ '@id': 'https://liftapp.ai/flip-image#howto' },
				{ '@id': 'https://liftapp.ai/flip-image#benefits' },
				{ '@id': 'https://liftapp.ai/flip-image#faq' },
				{ '@id': 'https://liftapp.ai/flip-image#why-lift' },
				{ '@id': 'https://liftapp.ai/flip-image#explore-tools' },
				{ '@id': 'https://liftapp.ai/flip-image#all-in-one' },
			],
		},
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/flip-image#product',
			name: 'Flip Image Online',
			description:
				"Mirror your photo online instantly with Lift's easy image flipper. No watermark. Upload photo, flip picture horizontally or vertically, create a perfect mirror image, and download in seconds.",
			url: 'https://liftapp.ai/flip-image',
			fileFormat: ['image/jpeg', 'image/png', 'image/webp'],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/flip-image#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: "Choose a photo from your device or take one using Lift's app",
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Flip Your Image',
					text: 'Use the flip control above your photo to flip image horizontally or vertically — instantly create a mirror image.',
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/flip-image#benefits',
			name: 'Who can benefit from Flip Image Online?',
			description:
				'Lift Flip Image helps social media creators, small business owners, students, digital marketers, and casual photo editors mirror and flip images online.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Social Media Creators — Create eye-catching mirror images for Instagram, TikTok, and Pinterest.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Small Business Owners — Flip product images for consistent storefront layouts and ads.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Students — Quickly flip a photo horizontally for presentations and creative projects.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Digital Marketers — Test different layouts with flip mirror picture variations.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Casual Photo Editors — Mirror image online and download your updated photo in just a few clicks.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.3da6de53.webp',
				name: 'Mirror Image Photo Editor for Everyone',
				description: 'Mirror image photo editor and flip pic online interface',
			},
		},
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/flip-image#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift Flip Image Tool?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift Flip Image Online is a browser-based mirror image photo editor that lets you flip image online in seconds. You can flip picture horizontally or vertically for social media, print, or personal projects.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift Flip Image Tool work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Upload your photo from your device gallery, then use the flip control above the image or choose vertical or horizontal flip. Instantly flip a photo online and download the final result in just a few clicks.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe — do you store my images?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes, completely safe. Your images are processed securely and automatically deleted from our servers immediately after compression. We never store, share, or access your files — your privacy is our priority.',
					},
				},
			],
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/flip-image#why-lift',
			name: 'Why Lift Flip Image',
			description:
				'High-quality results, intelligent rendering, cross-platform support, and budget-friendly pricing.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'High-quality results',
					description:
						'AI-powered technology delivers professional-grade visuals every time',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Intelligent rendering',
					description:
						'AI tailors the effect to the scene and subject for optimal results',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly designers with an affordable and intuitive tool',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyUse.ae83a89c.webp',
				name: 'Flip Image & Mirror Effect Tool',
				description: 'Flip image online and mirror effect for photos',
			},
		},
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/flip-image#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/flip-image#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},
		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Flip Image',
					item: 'https://liftapp.ai/flip-image',
				},
			],
		},
	],
};
